export class ListQueryExecutionsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "queryExecutions",
            "baseName": "queryExecutions",
            "type": "Array<QueryExecution>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return ListQueryExecutionsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
